export default {
      id: "icon--ski-nav-usage",
      viewBox: "0 0 25.7 25.7",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--ski-nav-usage",
      toString: function () {
        return this.url;
      }
    }